import base_config from "./base_config";

const gamma_config = {
  ...base_config,
  STAGE: "gamma",
  ACCOUNT: "991246619886",
  AUTH_PROVIDER: 'LASSO',  // Using LASSO authentication
  // Amplify config for cognito
  AMPLIFY_CONFIG: {
    aws_project_region: base_config.REGION,
    aws_cognito_region: base_config.REGION,
    aws_user_pools_id: "us-west-2_B2zOvYELV",
    aws_user_pools_web_client_id: "55jcfiqkus4d0itmomncbnfkgn",
    oauth: {
      domain: "msaservice-gamma.auth.us-west-2.amazoncognito.com",
      scope: base_config.TOKEN_SCOPES_ARRAY,
      redirectSignIn: base_config.CALL_BACK_URL,
      redirectSignOut: base_config.CALL_BACK_URL,
      responseType: base_config.OAUTH_RESPONSE_TYPE,
    },
  },

  // API Gateway Base URL
  BASE_URL: "https://v0z7cze3z4.execute-api.us-west-2.amazonaws.com/gamma",
};

export default gamma_config;
